import React, { Component } from 'react';
import PreviousBtn          from 'assets/icons/Previous.svg';
import NextBtn              from 'assets/icons/Next.svg';
import CalendarIcon         from 'assets/icons/Calendar 2.svg';
import RedCheck             from 'assets/icons/Red Check.svg';
import DayPickerInput       from 'react-day-picker/DayPickerInput'
import 'react-day-picker/lib/style.css';

import { formatDate, parseDate } from 'react-day-picker/moment';

class PageSelect extends Component {
  render() {
    return (
      <div className="ml-sm-4 my-2 my-sm-0 mb-0">
        <button onClick={ this.props.inherited.prevPage } className="arrow-btn-image">
          <img src={ PreviousBtn } alt="previous" className="page-prev-btn" />
        </button>

        <b className="font-size-6 px-2">{ this.props.inherited.page } of { this.props.inherited.total_pages }</b>

        <button onClick={ this.props.inherited.nextPage } className="arrow-btn-image">
          <img src={ NextBtn } alt="next" className="page-next-btn" />
        </button>
      </div>
    );
  }
}

class BookingAmounts extends Component {
  render() {
    const tagClasses  = 'text-white d-inline-block w-em-4 text-center py-1 mr-4';
    const wordClasses = 'mr-8';

    return (
      <div className="d-flex flex-wrap align-items-center mt-4">
        <div className="m-1">
          <span className={ tagClasses + ' bg-warning' }>{ this.props.stats.stats_opened }</span>
          <span className={ wordClasses }>Opened</span>
        </div>

        <div className="m-1">
          <span className={ tagClasses + ' bg-success' }>{ this.props.stats.stats_issued }</span>
          <span className={ wordClasses }>Issued</span>
        </div>

        <div className="m-1">
          <span className={ tagClasses + ' bg-primary' }>{ this.props.stats.stats_rejected }</span>
          <span className={ wordClasses }>Rejected</span>
        </div>

        <div className="m-1">
          <span className={ tagClasses + ' bg-grey' }>{ this.props.stats.stats_pending }</span>
          <span className={ wordClasses }>Pending</span>
        </div>

        <div className="m-1">
          <span className={ tagClasses + ' bg-danger' }>{ this.props.stats.stats_expired }</span>
          <span className={ wordClasses }>Expired</span>
        </div>
      </div>
    );
  }
}

export class GuaranteeLetterOptions extends Component {
  constructor(props) {
    super(props);
    this.changeStartDate  = this.startDayChange.bind(this);
    this.changeEndDate    = this.endDayChange.bind(this);
  }

  startDayChange(day) {
    this.props.changeDate(day, 'skip');
  }

  endDayChange(day) {
    this.props.changeDate('skip', day);
  }

  clearCalendar() {
    this.props.changeDate('', '');
  }

  render() {
    return (
      <div>
        <div className="d-sm-flex align-items-end">
          <div className="d-sm-flex align-items-end">
            <div>
              <p className="mb-1 text-lightgrey font-size-4">From</p>

              <span className="daypicker-container">
                <img src={ CalendarIcon } alt="calendar-icon" className="calendar-icon" />

                <DayPickerInput
                  formatDate={ formatDate }
                  parseDate={ parseDate }
                  format={ 'DD/MM/yyyy' }
                  value={ this.props.startDate }
                  placeholder={ formatDate(new Date()) }
                  onDayChange={ this.changeStartDate }
                />
              </span>
            </div>

            <span className="d-none d-sm-inline-block mx-3 font-size-11 fweight-300 mb-2">-</span>

            <div>
              <p className="mb-1 text-lightgrey font-size-4">To</p>

              <span className="daypicker-container">
                <img src={ CalendarIcon } alt="calendar-icon" className="calendar-icon" />

                <DayPickerInput
                  formatDate={ formatDate }
                  parseDate={ parseDate }
                  format={ 'DD/MM/yyyy' }
                  value={ this.props.endDate }
                  placeholder={ formatDate(new Date()) }
                  onDayChange={ this.changeEndDate }
                />
              </span>
            </div>

            <img src={ RedCheck } alt="clear-calendar" className="w-em-6 p-2 clickable ml-4 mb-3 conditional-display" displayed={ (!!this.props.startDate || !!this.props.endDate).toString() } onClick={() => this.clearCalendar() } />
          </div>

          <div className="d-none d-sm-block flex-grow-1"></div>
          <PageSelect inherited={ this.props } />
        </div>

        <div className="d-flex align-items-center pt-2">
          <BookingAmounts stats={ this.props.stats } />
        </div>
      </div>
    )
  }
}